import { API_BASE_URL, getHeaders } from './config'

export async function fetchDashboardData() {
  console.log('fetchDashboardData called')
  const response = await fetch(`${API_BASE_URL}/dashboard`, {
    headers: getHeaders()
  })
  console.log('fetchDashboardData response:', response.status)
  
  if (!response.ok) {
    throw new Error('Failed to fetch dashboard data')
  }
  
  return response.json()
}

export async function fetchDashboardStats() {
  const response = await fetch(`${API_BASE_URL}/dashboard/stats`, {
    headers: getHeaders()
  })
  
  if (!response.ok) {
    throw new Error('Failed to fetch dashboard stats')
  }
  
  return response.json()
}
